import { ChainId } from '@pancakeswap/chains'

export const ACCESS_TOKEN_SUPPORT_CHAIN_IDS = [ChainId.BSC_TESTNET]
